import {useEffect, useState} from "react";

export const WrongSwipeHeaderTopBar: React.FC<any> = ({data}) => {
  const [swipesCount, setSwipesCount] = useState({
    totalswipes: 0,
    validswipes: 0,
    invalidswipes: 0
  });
  useEffect(() => {
    if (data?.rows.length > 0) {
      let totalswipes = 0;
      let validswipes = 0;
      let invalidswipes = 0;
      for (const entry of data.rows) {
        invalidswipes += (entry.unassignedVehicles ?? []).reduce(
          (sum: any, v: any) => sum + (v.swipes?.length ?? 0),
          0
        );

        validswipes += (entry.assignedVehicles ?? []).reduce(
          (sum: any, v: any) => sum + (v.swipes?.length ?? 0),
          0
        );
      }
      totalswipes = invalidswipes + validswipes;

      setSwipesCount({
        totalswipes: totalswipes,
        validswipes: validswipes,
        invalidswipes: invalidswipes
      });
    }
  }, [data?.rows]);
  return (
    <>
      <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="rounded-lg bg-gray-100 p-4 shadow">
          <p className="text-sm text-gray-500">Total Swipes</p>
          <p className="text-2xl font-semibold text-gray-800">
            {swipesCount.totalswipes}
          </p>
        </div>
        <div className="rounded-lg bg-green-100 p-4 shadow">
          <p className="text-sm text-green-700">Valid Swipes</p>
          <p className="text-2xl font-semibold text-green-900">
            {swipesCount.validswipes}
          </p>
        </div>
        <div className="rounded-lg bg-red-100 p-4 shadow">
          <p className="text-sm text-red-700">Wrong Swipes</p>
          <p className="text-2xl font-semibold text-red-900">
            {swipesCount.invalidswipes}
          </p>
        </div>
      </div>
    </>
  );
};
